<template>
  <f7-app :params="f7params" id="app">
    <Navbar />
    <f7-page>
        
      <Particles />
      <About />
      <References />
      <Clients />
      <Contact />
      <div id="footer">
        &copy; Softresource, spol. s r.o.
      </div>
    </f7-page>
  </f7-app>

</template>

<script>
import Particles from "./components/Particles";
import Navbar from "./components/Navbar";
import About from "./components/About";
import References from "./components/References";
import Clients from "./components/Clients";
import Contact from "./components/Contact";
import AOS from "aos";
import $ from "jquery";

export default {
  name: "App",
  data() {
    return {
      f7params: {
        id: "io.softresource.web-softresource",
        name: "SoftResource",
        theme: "auto"
      }
    };
  },
  components: {
    Particles,
    Navbar,
    About,
    References,
    Clients,
    Contact
  },
  mounted(){
    $(".page-content").focus();
    $(function(){
      $('.page-content').scroll(function(){
        AOS.refresh();
        
      });
    });
  }
};

</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Roboto:400,700&display=swap&subset=latin-ext');
#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin: 0;
  height: 100%;
}
html, body {
  font-family: 'Roboto', sans-serif;
 background: #ffffff; height: 100%;position: relative;
 scroll-behavior: smooth;
}
.page{
  padding-top: 64px;
}
.container {
    max-width: 1080px;
    margin: 0 auto;
}
   img {
    width: 100%;
    height: auto;
  }
  section{
    min-height: 50vh;
    padding: 8% 0;
  }
  #footer{
    height: 64px;
    background: #f7f7f8;
    display: flex;
    justify-content: center;
    align-items: center;
  
  }
</style>
